import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { VerifyJWTToken } from "./VerifyJWTToken";

export default function Login({ setAuth }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      const result = async () => {
        const isValid = await VerifyJWTToken(token, setAuth);
        if (isValid) {
          setAuth(true);
          navigate("/");
          return;
        }
      };
      result();
  }}, []);


  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    try {

      const response = await fetch(process.env.REACT_APP_BACKEND_URL+"/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        // Save token to localStorage or state
        localStorage.setItem("authToken", data.token);
        setAuth(true); // Set authentication state
        navigate("/"); // Redirect to the dashboard
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };
  
  return (
    <div className="flex items-center justify-center h-screen">
      <form onSubmit={handleLogin} className="p-6 bg-white shadow-md rounded">
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <h2 className="text-2xl mb-4">Login</h2>
        <div className="mb-4">
          <label className="block mb-2">Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="border p-2 w-full"
          />
        </div>
        <div className="mb-4">
          <label className="block mb-2">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border p-2 w-full"
          />
        </div>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
          Login
        </button>
      </form>
    </div>
  );
}